export const TOGGLE_LABEL_MARKER = 'toggle-label-marker';
export const PERSIST_METADATA = 'persist-metadata';
